module.exports = __webpack_public_path__ + "img/ss4.212cc400.png";